/* Add copy and paste Icons for Attachment File copy March 13, 2022 */
/* Add faArrowLeft  Jun 18, 2023 */
/* Add faArrowDown and faArrowUp  Sep 30, 2023 */
/* Add faMicrophone, faMicrophoneSlash Feb 17, 2024 */
/* Add Caret Right, Address Book, QuestionCircle,  Apr 13, 2024 */
/* Add faPencilAlt May 30, 2025 */
export {
	faAddressBook,
   faAddressCard,
   faAngleLeft,
   faAngleRight,
   faArrowsAlt,
   faArrowCircleDown,
   faArrowCircleUp,
   faArrowDown,
   faArrowLeft,
   faArrowUp,
   faBan,
   faBars,
   faBell as fasBell,
   faBuilding,
   faBullhorn,
   faBullseye,
   faCalculator,
   faCalendarAlt,
   faCalendarCheck,
   faCalendarDay,
   faCalendarTimes,
   faCamera,
   faCaretDown,
   faCaretRight,
   faCaretUp,
   faChartBar,
   faChartLine,
   faChartPie,
   faCheck,
   faCheckCircle,
   faCheckDouble,
   faChevronDown,
   faChevronLeft,
   faChevronRight,
   faChevronUp,
   faClock,
   faClone,
   faClipboardList,
   faClipboardCheck,
   faCog,
   faCommentDots,
   faComments,
   faCompressAlt,
   faCopy,
   faCubes,
   faDatabase,
   faDesktop,
   faDownload,
   faDotCircle,
   faEdit,
   faEnvelope,
   faExclamation,
   faExclamationCircle,
   faExclamationTriangle,
   faExpandAlt,
   faExternalLinkAlt,
   faEye,
   faEyeSlash,
   faFax,
   faFile,
   faFileAlt,
   faFileArchive,
   faFileCsv,
   faFileExcel,
   faFileExport,
   faFileImage,
   faFileImport,
   faFilePdf,
   faFilePowerpoint,
   faFileWord,
   faFilter,
   faFolder,
   faFolderMinus,
   faFolderOpen,
   faFolderPlus,
   faHistory,
   faInfoCircle,
   faKey,
   faListUl,
   faMap,
   faMicrophone,
   faMicrophoneSlash,
   faMinus,
   faMobile,
   faMobileAlt,
   faMoneyCheck,
   faPauseCircle,
   faPaste,
   faPen,
   faPenAlt,
   faPencilAlt,
   faPhone,
   faPlus,
   faPlayCircle,
   faQuestion,
   faQuestionCircle,
   faSave,
   faSearch,
   faSignOutAlt,
   faSitemap,
   // faSortAlphaDown,
   // faSortAlphaDownAlt,
   faSync,
   faTabletAlt,
   faTachometerAlt,
   faTable,
   faTasks,
   faThLarge,
   faThList,
   faTimes,
   faTimesCircle,
   faTools,
   faTrafficLight,
   faTrashAlt,
   faTrophy,
   faUndo,
   faUpload,
   faUser,
   faUserAlt,
   faUserCheck,
   faUserCog,
   faUserEdit,
   faUserFriends,
   faUserPlus,
   faUserShield,
   faWater,


} from '@fortawesome/free-solid-svg-icons';

export {
   faBell,
   faBellSlash,
   faCalendar,
   faCalendarAlt as farCalendarAlt,
   faCalendarCheck as farCalendarCheck,
   faCheckSquare as farCheckSquare,
   //faEnvelope,
} from '@fortawesome/free-regular-svg-icons';


/*
const arrowDownIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const crossIcon = `<svg width="14" height="14" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="currentColor" d="M12.78 4.28a.75.75 0 00-1.06-1.06L8 6.94 4.28 3.22a.75.75 0 00-1.06 1.06L6.94 8l-3.72 3.72a.75.75 0 101.06 1.06L8 9.06l3.72 3.72a.75.75 0 101.06-1.06L9.06 8l3.72-3.72z"/></svg>`;
const crossCircleIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 12.25C9.89741 12.25 12.25 9.89741 12.25 7C12.25 4.10259 9.89741 1.75 7 1.75C4.10259 1.75 1.75 4.10259 1.75 7C1.75 9.89741 4.10259 12.25 7 12.25Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.25 5.25L8.75 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.75 5.25L5.25 8.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const userIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 640 640"><path d="M320 312C386.3 312 440 258.3 440 192C440 125.7 386.3 72 320 72C253.7 72 200 125.7 200 192C200 258.3 253.7 312 320 312zM290.3 368C191.8 368 112 447.8 112 546.3C112 562.7 125.3 576 141.7 576L498.3 576C514.7 576 528 562.7 528 546.3C528 447.8 448.2 368 349.7 368L290.3 368z"/></svg>`
const projectIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 640 640"><path d="M439.4 96L448 96C483.3 96 512 124.7 512 160L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 160C128 124.7 156.7 96 192 96L200.6 96C211.6 76.9 232.3 64 256 64L384 64C407.7 64 428.4 76.9 439.4 96zM376 176C389.3 176 400 165.3 400 152C400 138.7 389.3 128 376 128L264 128C250.7 128 240 138.7 240 152C240 165.3 250.7 176 264 176L376 176zM256 320C256 302.3 241.7 288 224 288C206.3 288 192 302.3 192 320C192 337.7 206.3 352 224 352C241.7 352 256 337.7 256 320zM288 320C288 333.3 298.7 344 312 344L424 344C437.3 344 448 333.3 448 320C448 306.7 437.3 296 424 296L312 296C298.7 296 288 306.7 288 320zM288 448C288 461.3 298.7 472 312 472L424 472C437.3 472 448 461.3 448 448C448 434.7 437.3 424 424 424L312 424C298.7 424 288 434.7 288 448zM224 480C241.7 480 256 465.7 256 448C256 430.3 241.7 416 224 416C206.3 416 192 430.3 192 448C192 465.7 206.3 480 224 480z"/></svg>`;
const generateIcon = `<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" fill="currentColor" class="bi bi-stars" viewBox="0 0 16 16"><path d="M7.657 6.247c0.11 -0.33 0.576 -0.33 0.686 0l0.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936 0.645c0.33 0.11 0.33 0.576 0 0.686l-1.937 0.645a2.89 2.89 0 0 0 -1.828 1.829l-0.645 1.936a0.361 0.361 0 0 1 -0.686 0l-0.645 -1.937a2.89 2.89 0 0 0 -1.828 -1.828l-1.937 -0.645a0.361 0.361 0 0 1 0 -0.686l1.937 -0.645a2.89 2.89 0 0 0 1.828 -1.828zM3.794 1.148a0.217 0.217 0 0 1 0.412 0l0.387 1.162c0.173 0.518 0.579 0.924 1.097 1.097l1.162 0.387a0.217 0.217 0 0 1 0 0.412l-1.162 0.387A1.73 1.73 0 0 0 4.593 5.69l-0.387 1.162a0.217 0.217 0 0 1 -0.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162 -0.387a0.217 0.217 0 0 1 0 -0.412l1.162 -0.387A1.73 1.73 0 0 0 3.407 2.31zM10.863 0.099a0.145 0.145 0 0 1 0.274 0l0.258 0.774c0.115 0.346 0.386 0.617 0.732 0.732l0.774 0.258a0.145 0.145 0 0 1 0 0.274l-0.774 0.258a1.16 1.16 0 0 0 -0.732 0.732l-0.258 0.774a0.145 0.145 0 0 1 -0.274 0l-0.258 -0.774a1.16 1.16 0 0 0 -0.732 -0.732L9.1 2.137a0.145 0.145 0 0 1 0 -0.274l0.774 -0.258c0.346 -0.115 0.617 -0.386 0.732 -0.732z" stroke-width="1"></path></svg>`;
const uploadPhotoIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24"> <path d="M19,13a1,1,0,0,0-1,1v.38L16.52,12.9a2.79,2.79,0,0,0-3.93,0l-.7.7L9.41,11.12a2.85,2.85,0,0,0-3.93,0L4,12.6V7A1,1,0,0,1,5,6h7a1,1,0,0,0,0-2H5A3,3,0,0,0,2,7V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V14A1,1,0,0,0,19,13ZM5,20a1,1,0,0,1-1-1V15.43l2.9-2.9a.79.79,0,0,1,1.09,0l3.17,3.17L15.46,20Zm13-1a.89.89,0,0,1-.18.53L13.31,15l.7-.7a.77.77,0,0,1,1.1,0L18,17.21ZM22.71,4.29l-3-3a1,1,0,0,0-.33-.21,1,1,0,0,0-.76,0,1,1,0,0,0-.33.21l-3,3a1,1,0,0,0,1.42,1.42L18,4.41V10a1,1,0,0,0,2,0V4.41l1.29,1.3a1,1,0,0,0,1.42,0A1,1,0,0,0,22.71,4.29Z"/></svg>`;
const calendarIcon = ` <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" class="bi bi-calendar" viewBox="0 0 16 16"><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z" /></svg>`;
const refreshIcon = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 3V8M3 8H8M3 8L6 5.29168C7.59227 3.86656 9.69494 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.71683 21 4.13247 18.008 3.22302 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const filterIcon = ` <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>`;
const bookIcon = `<svg fill="currentColor" width="16" height="16" viewBox="0 3 14 14" xmlns="http://www.w3.org/2000/svg"><path d="M 6.55466,11.542 C 6.10897,11.0187 5.36501,10.459 4.6445,10.1049 3.91698,9.7473 3.22595,9.5487 2.44138,9.4719 2.28669,9.4569 2.15844,9.4429 2.15639,9.4409 c -0.002,0 0.002,-1.6151 0.01,-3.5846 l 0.0132,-3.5808 0.14284,0.014 c 0.87708,0.087 1.85601,0.4184 2.59669,0.8803 0.63833,0.398 1.29749,1.0126 1.71774,1.6015 l 0.10576,0.1482 0,3.4014 c 0,1.8707 -0.008,3.401 -0.0176,3.4007 -0.01,-3e-4 -0.0861,-0.081 -0.16992,-0.1794 z m 0.72656,-3.2297 0,-3.4156 0.20424,-0.2729 C 7.74623,4.2754 8.27075,3.7505 8.61758,3.491 9.54472,2.7971 10.55044,2.405 11.70505,2.287 l 0.14648,-0.015 0,3.5858 0,3.5859 -0.16992,0.016 C 10.0739,9.6093 8.6801,10.2726 7.5899,11.4068 l -0.30868,0.3212 0,-3.4156 z m 0.9961,3.1835 c 0.63101,-0.592 1.46635,-1.0624 2.30546,-1.2985 0.4391,-0.1235 1.01012,-0.2097 1.38918,-0.2097 0.19874,0 0.30898,-0.043 0.37116,-0.1451 0.0468,-0.077 0.0473,-0.1101 0.0474,-3.0157 l 8e-5,-2.9382 0.0879,0.016 c 0.0483,0.01 0.18544,0.048 0.30468,0.086 l 0.2168,0.069 0,3.6669 c 0,2.0168 -0.008,3.6669 -0.0179,3.6669 -0.01,0 -0.15489,-0.031 -0.32227,-0.069 -0.66143,-0.149 -1.20614,-0.2002 -1.92152,-0.1809 -0.86772,0.024 -1.54209,0.145 -2.34375,0.422 l -0.30469,0.1053 0.1875,-0.1759 z m -2.67188,0.057 C 5.27252,11.4336 4.7227,11.2931 4.35153,11.2325 c -0.50468,-0.082 -0.85286,-0.1038 -1.4714,-0.09 -0.61458,0.013 -0.98632,0.056 -1.49344,0.1711 -0.1418,0.032 -0.28682,0.065 -0.32227,0.072 l -0.0644,0.014 1.1e-4,-3.6767 1.2e-4,-3.6768 0.27529,-0.08 c 0.1514,-0.044 0.28847,-0.085 0.30458,-0.09 0.0233,-0.01 0.0293,0.589 0.0293,2.9349 0,3.2057 -0.007,3.027 0.12978,3.1169 0.0476,0.031 0.1465,0.045 0.42893,0.062 1.12246,0.064 2.18752,0.4409 3.05702,1.0822 0.1875,0.1383 0.63749,0.5181 0.66328,0.5598 0.018,0.029 0.006,0.026 -0.28292,-0.078 z"/></svg>`;
const globeIcon = `<svg fill="currentColor" width="16" height="16" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M 16 3 C 8.832 3 3 8.832 3 16 C 3 23.168 8.832 29 16 29 C 23.168 29 29 23.168 29 16 C 29 8.832 23.168 3 16 3 z M 16 5 C 16.338 5 16.67 5.0207813 17 5.0507812 L 17 6 L 19 6 L 19 5.4257812 C 21.458 6.1247812 23.566 7.6543125 25 9.6953125 L 25 13 L 26 15 L 26 16 L 27 16 C 27 16.366 26.980312 16.728938 26.945312 17.085938 C 26.936312 17.181938 26.916297 17.274141 26.904297 17.369141 C 26.871297 17.632141 26.837156 17.893391 26.785156 18.150391 C 26.766156 18.246391 26.74075 18.340547 26.71875 18.435547 C 26.66075 18.689547 26.598437 18.942453 26.523438 19.189453 C 26.497438 19.274453 26.467453 19.357406 26.439453 19.441406 C 26.355453 19.695406 26.266063 19.947359 26.164062 20.193359 C 26.134062 20.265359 26.101312 20.33525 26.070312 20.40625 C 25.958313 20.66125 25.840938 20.91225 25.710938 21.15625 C 25.679938 21.21525 25.646281 21.273078 25.613281 21.330078 C 25.473281 21.582078 25.325016 21.826406 25.166016 22.066406 C 25.135016 22.113406 25.102312 22.161984 25.070312 22.208984 C 24.902313 22.453984 24.724109 22.691875 24.537109 22.921875 C 24.506109 22.959875 24.478266 22.996203 24.447266 23.033203 C 24.253266 23.266203 24.047937 23.489078 23.835938 23.705078 C 23.804938 23.736078 23.775141 23.769781 23.744141 23.800781 C 23.527141 24.015781 23.300406 24.221969 23.066406 24.417969 C 23.033406 24.445969 23.004703 24.474953 22.970703 24.501953 C 22.736703 24.693953 22.491187 24.872922 22.242188 25.044922 C 22.203187 25.071922 22.167906 25.102906 22.128906 25.128906 C 21.889906 25.289906 21.640672 25.436125 21.388672 25.578125 C 20.214672 26.237125 18.909578 26.690859 17.517578 26.880859 L 21.529297 23.857422 L 22.628906 22.757812 L 24 20 L 24 19 L 22 18 L 21 18 L 19 16 L 17 16 L 16 17 L 16 18 L 15 19 L 15 21 L 17 22.599609 L 15.023438 26.951172 C 9.4144375 26.453172 5 21.735 5 16 C 5 12.592 6.559 9.5414844 9 7.5214844 L 9 8 L 8 9 L 8 11.199219 L 9 15 L 14 17 L 15 17 L 15 16 L 12 15 L 12 13 L 15 13 L 16 10.5 L 18 9 L 18 8 L 15 6 L 13.5625 5.28125 C 14.3475 5.10325 15.161 5 16 5 z M 15 14 L 15 15 L 17 15 L 17 14 L 15 14 z"/></svg>`;
const arrowRightCircleIcon = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M10.74 15.53L14.26 12L10.74 8.46997" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const arrowDownFilled = `<svg width="10" height="10" viewBox="4 7 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.9188 8.17969H11.6888H6.07877C5.11877 8.17969 4.63877 9.33969 5.31877 10.0197L10.4988 15.1997C11.3288 16.0297 12.6788 16.0297 13.5088 15.1997L15.4788 13.2297L18.6888 10.0197C19.3588 9.33969 18.8788 8.17969 17.9188 8.17969Z" fill="currentColor"/></svg>`;
const arrowUpFilled = `<svg width="10" height="10" viewBox="4 7 16 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.6806 13.9783L15.4706 10.7683L13.5106 8.79828C12.6806 7.96828 11.3306 7.96828 10.5006 8.79828L5.32056 13.9783C4.64056 14.6583 5.13056 15.8183 6.08056 15.8183H11.6906H17.9206C18.8806 15.8183 19.3606 14.6583 18.6806 13.9783Z" fill="currentColor"/></svg>`;
const loadingSmIcon = `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" class="hds-flight-icon--animation-loading"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z" opacity=".2"/><path d="M7.25.75A.75.75 0 018 0a8 8 0 018 8 .75.75 0 01-1.5 0A6.5 6.5 0 008 1.5a.75.75 0 01-.75-.75z"/></g></svg>`;
const loadingLgIcon = `<svg width="30" height="30" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" class="hds-flight-icon--animation-loading"><g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd"><path d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM0 8a8 8 0 1116 0A8 8 0 010 8z" opacity=".2"/><path d="M7.25.75A.75.75 0 018 0a8 8 0 018 8 .75.75 0 01-1.5 0A6.5 6.5 0 008 1.5a.75.75 0 01-.75-.75z"/></g></svg>`;
export {
   arrowDownIcon,
   crossIcon,
   crossCircleIcon,
   userIcon,
   projectIcon,
   generateIcon,
   uploadPhotoIcon,
   calendarIcon,
   refreshIcon,
   filterIcon,
   bookIcon,
   globeIcon, 
   arrowRightCircleIcon,
   arrowDownFilled,
   arrowUpFilled,
   loadingSmIcon,
   loadingLgIcon
};
*/

